<script>
export default {
  name: 'FrontageLink',
  props: {
    to: {
      type: String,
      required: true,
    },
    params: {
      type: Object,
      required: false
    }
  },
  render (h) {
    const data = {
      href: "#", 
      class: "frontage-link", 
      on: {
        click: this.redirect
      }
    }
    return h('a', data, this.$slots.default)    
  },
  methods: {
    redirect() {
      this.$frontageApi.navigateTo(this.to, this.params)
    }
  }
}
</script>

<style lang="scss" scoped>
a.frontage-link {
  color: var(--link-color);
}

.frontage-link {
  width: 100%;
}
</style>